import { Service } from '@/types/service.types';
import driveSourceData from './services.drivesource.json';
import homeSourceData from './services.homesource.json';

function getData(): Service[] {
    switch (import.meta.env.VITE_ASSISTANT_DISPLAY_NAME) {
        case 'DriveSource': return driveSourceData as Service[];
        case 'HomeSource': return homeSourceData as Service[];
        default: return [];
    }
}

export function getServices(): Service[] {
    return getData();
}

export function getServiceBySlug(slug: string): Service | undefined {
    return getData().find(s => s.slug === slug);
}
